module.exports = {
  loginPrefix: 'login',
  classroomCourseware: '/classroom-courseware',
  intelligenceCourseware: '/intelligence-courseware',
  intelligenceResource: '/intelligence-resource',
};
